export default {
  debugApiHost: 'http://localhost:3030',
  // debugApiHost:'http://schengen-insure.webdev.vychozi.cz/api/',
  cldr: 'https://cldr.sprinxcrm.com',  
  redirects: [
    { from: '/sitemap_uk.xml', to: '/sitemap_en.xml' },
    { from: '/en/blog', to: '/blog' },
    { from: '/axa', to: '/en' },
    { from: '/axa/privacy-policy', to: '/en/privacy-policy' },
    { from: '/docs/guide.pdf', to: '/guide/guide.pdf' },
    { from: '/axa/schengen-visa-insurance', to: '/en/schengen-visa' },
    { from: '/axa/testimonials', to: '/en/testimonials' },
    { from: '/axa/calculator', to: '/en/calculator' },
    { from: '/uk/perevahy', to: '/en' },
    { from: '/axa/for-whom', to: '/en/for-whom' },
    { from: '/axa/schengen-visa', to: '/en/schengen-visa' },
    { from: '/uk/shenhenska-zona', to: '/en/schengen-zone' },
    { from: '/en&sa=U', to: '/en' },
    { from: '/cookies', to: '/en/cookies' },
    { from: '/uk', to: '/en' },
    { from: '/uk/nashi-partnery', to: '/en/our-partners' },
  ],
};



// WEBPACK FOOTER //
// ./src/config.js